export default __webpack_public_path__ + "static/media/crown-queen-1.b3a9ae57.svg";